<template>
  <div class="flex items-center justify-center flex-col min-h-screen">
    <img
      src="../assets/warning.png"
      class="w-56"
      alt="mill under construction"
    />
    <div class="text-4xl font-bold text-center">
      <h1 class="text-yellow-500">Mill Site is Under Construction</h1>
      <p class="text-base tracking-wide">Please Wait for a few more months</p>
      <router-link class="btn btn-warning mt-5" :to="{ name: 'Home' }"
        >Okay</router-link
      >
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
